import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CircularProgress,
    Typography,
    useTheme,
} from "@mui/material";
import { TodayRounded } from "@mui/icons-material";
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import { Report_corporateEntriesByWeekday } from "../../../network/api/report.api";

const _DashWeekdayActivity = ({ corporateId }) => {
    const theme = useTheme();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!corporateId) return;
        setLoading(true);
        Report_corporateEntriesByWeekday(corporateId)
            .then((res) => {
                setRows(res?.data?.Data?.Rows || []);
            })
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, [corporateId]);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <Box
                    sx={{
                        p: 1.5,
                        borderRadius: 2.5,
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                        direction: 'rtl',
                        textAlign: 'right',
                    }}
                >
                    <Typography variant="caption" sx={{ fontWeight: 800, display: 'block', mb: 0.5 }}>
                        {label}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                        ورود ثبت‌شده: <strong>{payload[0].value} بار</strong>
                    </Typography>
                </Box>
            );
        }
        return null;
    };

    return (
        <Card
            elevation={0}
            sx={{
                p: { xs: 2, sm: 2.5 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 2 }}>
                <Box
                    sx={{
                        width: 38,
                        height: 38,
                        borderRadius: 2.5,
                        bgcolor: 'rgba(237, 108, 2, 0.1)',
                        color: 'warning.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <TodayRounded sx={{ fontSize: 20 }} />
                </Box>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                        توزیع تردد ورزشی در روزهای هفته
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        کدام روزهای هفته پرسنل بیشترین مراجعه به باشگاه‌ها را دارند؟
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ width: '100%', height: 260, mt: 'auto' }}>
                {loading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <CircularProgress size={32} />
                    </Box>
                ) : rows.length === 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Typography variant="body2" color="text.secondary">داده‌ای ثبت نشده است.</Typography>
                    </Box>
                ) : (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={rows} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} vertical={false} />
                            <XAxis
                                dataKey="Label"
                                stroke={theme.palette.text.secondary}
                                fontSize={11}
                                tickLine={false}
                            />
                            <YAxis
                                stroke={theme.palette.text.secondary}
                                fontSize={11}
                                tickLine={false}
                            />
                            <Tooltip content={<CustomTooltip />} />
                            <Bar
                                dataKey="Count"
                                fill={theme.palette.primary.main}
                                radius={[6, 6, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </Box>
        </Card>
    );
};

export default _DashWeekdayActivity;
